<sl-form #checkConfigForm [model]="entity" [readOnly]="readOnly" [form]="form" [fields]="fields" [options]="options"></sl-form>
